var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAffiliate = function SvgAffiliate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.164 13.333-.834 3.334 1.667 1.666H1.664v-1.666a5 5 0 0 1 5-5H8.33zm4.166-1.666a5 5 0 0 1 5 5v1.666H9.997l1.667-1.666-.834-3.334.834-1.666zm-3.332-10a4.167 4.167 0 1 1 0 8.333 4.167 4.167 0 0 1 0-8.333"
  })));
};
export default SvgAffiliate;